import { types } from "mobx-state-tree";

import { MenuItems } from "../../components/secondary-menu/SecondaryMenu";

export enum MyAccountMenuItemsPages {
  EditAccountDetails,
  RequestOrganization,
}

export const MyAccountMenuItemsModel = types
  .model({
    menuItemPage: types.maybe(types.frozen<MyAccountMenuItemsPages>()),
  })
  .actions((self) => {
    return {
      getStaticItems(): MenuItems {
        return {
          "general.general": {
            items: [
              {
                id: "secondary-menu-users-details",
                labelKey: "general.users.details",
                path:
                  self.menuItemPage === MyAccountMenuItemsPages.EditAccountDetails ? "/edit" : "",
                canAccess: true,
              },
            ],
            defaultOpen: true,
          },
          "general.organizations": {
            items: [
              {
                id: "secondary-menu-users-organizations",
                labelKey: "general.my-organizations",
                path: "/organizations",
                canAccess: true,
              },
              {
                id: "secondary-menu-users-organizations",
                labelKey: "general.organization.requests",
                path:
                  self.menuItemPage === MyAccountMenuItemsPages.RequestOrganization
                    ? "/organizations/request-organization"
                    : "/organizations/organization-requests",
                canAccess: true,
              },
              {
                id: "secondary-menu-users-collaboration-requests",
                labelKey: "general.collaboration-requests",
                path: "/organizations/collaboration-requests",
                canAccess: true,
              },
            ],
            defaultOpen: true,
          },
        };
      },
    };
  });
